import { render, staticRenderFns } from "./MyAccountAssetsAwaitingApproval.vue?vue&type=template&id=bd210036"
import script from "./MyAccountAssetsAwaitingApproval.vue?vue&type=script&lang=js"
export * from "./MyAccountAssetsAwaitingApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports